import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useMutationFacilityAvailabilityOverrideCreate({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({
      newOverride,
    }: {
      newOverride: Parameters<
        ApiType["availabilityApi"]["createFacilityOverride"]
      >[0];
    }) => {
      const response =
        await api.availabilityApi.createFacilityOverride(newOverride);
      return response.data;
    },
    onSuccess: async (_, { newOverride: { facilityIdList } }) =>
      facilityIdList.forEach(async (facilityId) => {
        await queryClient.invalidateQueries({
          queryKey: availabilityQueryKeys.allFacilityOverrides(facilityId),
        });
      }),
  });

  return mutation;
}
